/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangeOnceOffSourceOfMoneyOrchestration,
  DeleteProductOrchestration,
  ErrorResult,
  InvestmentDetailsProductViewModel,
  NotFoundErrorResult,
  Result,
  ResultOfInvestmentDetailsProductViewModel,
  ResultOfInvestmentDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ChangeOnceOffSourceOfMoneyOrchestrationFromJSON,
    ChangeOnceOffSourceOfMoneyOrchestrationToJSON,
    DeleteProductOrchestrationFromJSON,
    DeleteProductOrchestrationToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    InvestmentDetailsProductViewModelFromJSON,
    InvestmentDetailsProductViewModelToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfInvestmentDetailsProductViewModelFromJSON,
    ResultOfInvestmentDetailsProductViewModelToJSON,
    ResultOfInvestmentDetailsViewModelFromJSON,
    ResultOfInvestmentDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface InvestmentDetailsChangeProductAndSourceOfFundsRequest {
    request: ChangeOnceOffSourceOfMoneyOrchestration;
}

export interface InvestmentDetailsDeleteRequest {
    deleteProductOrchestration: DeleteProductOrchestration;
}

export interface InvestmentDetailsDeleteAllUnitTransfersRequest {
    unitTransferId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteCashTransferRequest {
    cashTransferId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteFeeDisinvestmentAssetSplitRequest {
    id: number;
}

export interface InvestmentDetailsDeleteFundAllocationSplitRequest {
    productSelectedAssetId: number;
    proposalId?: number;
}

export interface InvestmentDetailsDeleteJustPortfolioRequest {
    justPortfolioId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteJustPortfolioIncomeAssetSplitRequest {
    assetCode: number;
    proposalId?: number;
}

export interface InvestmentDetailsDeleteLumpSumPremiumRequest {
    lumpSumId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteOnceOffInvestmentRequest {
    proposalId: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeletePhasingInRequest {
    phasingInId: number;
}

export interface InvestmentDetailsDeletePhasingInByProductIdRequest {
    productId: number;
}

export interface InvestmentDetailsDeletePhasingInTargetFundRequest {
    phasingInTargetFundId: number;
    phasingInId: string;
}

export interface InvestmentDetailsDeleteRecurringContributionPremiumRequest {
    recurringContributionId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteRegularWithdrawalRequest {
    regularWithdrawalId: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteTFSATTransferPremiumRequest {
    transferId: number;
    paymentCategoryId?: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsDeleteUnitTransferRequest {
    unitTransferFundId: number;
    productId?: number;
    proposalId?: number;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsFetchRequest {
    proposalId: number;
}

export interface InvestmentDetailsSubmitFundSelectionRequest {
    productId: number;
    investmentDetails: InvestmentDetailsProductViewModel;
    proposalId?: number;
    isNextStep?: boolean;
    isComplete?: boolean;
    proceedWithDataLoss?: boolean;
}

export interface InvestmentDetailsSubmitInvestmentDetailsRequest {
    productId: number;
    investmentDetails: InvestmentDetailsProductViewModel;
    proposalId?: number;
    isNextStep?: boolean;
    isComplete?: boolean;
    proceedWithDataLoss?: boolean;
}

/**
 * 
 */
export class InvestmentDetailsApi extends runtime.BaseAPI {

    /**
     * Clears the currently selected product by deleting the product and all sub tables, and creates a new product with the prescribed OnceOffSourceOfMoney
     */
    async investmentDetailsChangeProductAndSourceOfFundsRaw(requestParameters: InvestmentDetailsChangeProductAndSourceOfFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfInvestmentDetailsProductViewModel>> {
        if (requestParameters.request === null || requestParameters.request === undefined) {
            throw new runtime.RequiredError('request','Required parameter requestParameters.request was null or undefined when calling investmentDetailsChangeProductAndSourceOfFunds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/change-source-of-money`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeOnceOffSourceOfMoneyOrchestrationToJSON(requestParameters.request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfInvestmentDetailsProductViewModelFromJSON(jsonValue));
    }

    /**
     * Clears the currently selected product by deleting the product and all sub tables, and creates a new product with the prescribed OnceOffSourceOfMoney
     */
    async investmentDetailsChangeProductAndSourceOfFunds(requestParameters: InvestmentDetailsChangeProductAndSourceOfFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfInvestmentDetailsProductViewModel> {
        const response = await this.investmentDetailsChangeProductAndSourceOfFundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a product
     */
    async investmentDetailsDeleteRaw(requestParameters: InvestmentDetailsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.deleteProductOrchestration === null || requestParameters.deleteProductOrchestration === undefined) {
            throw new runtime.RequiredError('deleteProductOrchestration','Required parameter requestParameters.deleteProductOrchestration was null or undefined when calling investmentDetailsDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/product`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteProductOrchestrationToJSON(requestParameters.deleteProductOrchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a product
     */
    async investmentDetailsDelete(requestParameters: InvestmentDetailsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all unit transfers for a product.
     */
    async investmentDetailsDeleteAllUnitTransfersRaw(requestParameters: InvestmentDetailsDeleteAllUnitTransfersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.unitTransferId === null || requestParameters.unitTransferId === undefined) {
            throw new runtime.RequiredError('unitTransferId','Required parameter requestParameters.unitTransferId was null or undefined when calling investmentDetailsDeleteAllUnitTransfers.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/all-unit-transfers/{unitTransferId}`.replace(`{${"unitTransferId"}}`, encodeURIComponent(String(requestParameters.unitTransferId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes all unit transfers for a product.
     */
    async investmentDetailsDeleteAllUnitTransfers(requestParameters: InvestmentDetailsDeleteAllUnitTransfersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteAllUnitTransfersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the cash transfer.
     */
    async investmentDetailsDeleteCashTransferRaw(requestParameters: InvestmentDetailsDeleteCashTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.cashTransferId === null || requestParameters.cashTransferId === undefined) {
            throw new runtime.RequiredError('cashTransferId','Required parameter requestParameters.cashTransferId was null or undefined when calling investmentDetailsDeleteCashTransfer.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/cash-transfer/{cashTransferId}`.replace(`{${"cashTransferId"}}`, encodeURIComponent(String(requestParameters.cashTransferId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the cash transfer.
     */
    async investmentDetailsDeleteCashTransfer(requestParameters: InvestmentDetailsDeleteCashTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteCashTransferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the fee disinvestment asset split.
     */
    async investmentDetailsDeleteFeeDisinvestmentAssetSplitRaw(requestParameters: InvestmentDetailsDeleteFeeDisinvestmentAssetSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling investmentDetailsDeleteFeeDisinvestmentAssetSplit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/fee-disinvestment-asset-split/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the fee disinvestment asset split.
     */
    async investmentDetailsDeleteFeeDisinvestmentAssetSplit(requestParameters: InvestmentDetailsDeleteFeeDisinvestmentAssetSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteFeeDisinvestmentAssetSplitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the fund allocation split.
     */
    async investmentDetailsDeleteFundAllocationSplitRaw(requestParameters: InvestmentDetailsDeleteFundAllocationSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productSelectedAssetId === null || requestParameters.productSelectedAssetId === undefined) {
            throw new runtime.RequiredError('productSelectedAssetId','Required parameter requestParameters.productSelectedAssetId was null or undefined when calling investmentDetailsDeleteFundAllocationSplit.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/fund-allocation-split/{productSelectedAssetId}`.replace(`{${"productSelectedAssetId"}}`, encodeURIComponent(String(requestParameters.productSelectedAssetId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the fund allocation split.
     */
    async investmentDetailsDeleteFundAllocationSplit(requestParameters: InvestmentDetailsDeleteFundAllocationSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteFundAllocationSplitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the just portfolio.
     */
    async investmentDetailsDeleteJustPortfolioRaw(requestParameters: InvestmentDetailsDeleteJustPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.justPortfolioId === null || requestParameters.justPortfolioId === undefined) {
            throw new runtime.RequiredError('justPortfolioId','Required parameter requestParameters.justPortfolioId was null or undefined when calling investmentDetailsDeleteJustPortfolio.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/just-portfolio/{justPortfolioId}`.replace(`{${"justPortfolioId"}}`, encodeURIComponent(String(requestParameters.justPortfolioId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the just portfolio.
     */
    async investmentDetailsDeleteJustPortfolio(requestParameters: InvestmentDetailsDeleteJustPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteJustPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the Just portfolio income asset split.
     */
    async investmentDetailsDeleteJustPortfolioIncomeAssetSplitRaw(requestParameters: InvestmentDetailsDeleteJustPortfolioIncomeAssetSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.assetCode === null || requestParameters.assetCode === undefined) {
            throw new runtime.RequiredError('assetCode','Required parameter requestParameters.assetCode was null or undefined when calling investmentDetailsDeleteJustPortfolioIncomeAssetSplit.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/just-portfolio-income-asset-split/{assetCode}`.replace(`{${"assetCode"}}`, encodeURIComponent(String(requestParameters.assetCode))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the Just portfolio income asset split.
     */
    async investmentDetailsDeleteJustPortfolioIncomeAssetSplit(requestParameters: InvestmentDetailsDeleteJustPortfolioIncomeAssetSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteJustPortfolioIncomeAssetSplitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the lump sum premium.
     */
    async investmentDetailsDeleteLumpSumPremiumRaw(requestParameters: InvestmentDetailsDeleteLumpSumPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.lumpSumId === null || requestParameters.lumpSumId === undefined) {
            throw new runtime.RequiredError('lumpSumId','Required parameter requestParameters.lumpSumId was null or undefined when calling investmentDetailsDeleteLumpSumPremium.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/lump-sum/{lumpSumId}`.replace(`{${"lumpSumId"}}`, encodeURIComponent(String(requestParameters.lumpSumId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the lump sum premium.
     */
    async investmentDetailsDeleteLumpSumPremium(requestParameters: InvestmentDetailsDeleteLumpSumPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteLumpSumPremiumRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the once-off investment including lump sum, cash transfer, and unit transfer.
     */
    async investmentDetailsDeleteOnceOffInvestmentRaw(requestParameters: InvestmentDetailsDeleteOnceOffInvestmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling investmentDetailsDeleteOnceOffInvestment.');
        }

        const queryParameters: any = {};

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/once-off-investment/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the once-off investment including lump sum, cash transfer, and unit transfer.
     */
    async investmentDetailsDeleteOnceOffInvestment(requestParameters: InvestmentDetailsDeleteOnceOffInvestmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteOnceOffInvestmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the phasing ins.
     */
    async investmentDetailsDeletePhasingInRaw(requestParameters: InvestmentDetailsDeletePhasingInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.phasingInId === null || requestParameters.phasingInId === undefined) {
            throw new runtime.RequiredError('phasingInId','Required parameter requestParameters.phasingInId was null or undefined when calling investmentDetailsDeletePhasingIn.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/phase-in/{phasingInId}`.replace(`{${"phasingInId"}}`, encodeURIComponent(String(requestParameters.phasingInId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the phasing ins.
     */
    async investmentDetailsDeletePhasingIn(requestParameters: InvestmentDetailsDeletePhasingInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeletePhasingInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the phasing in by product identifier.
     */
    async investmentDetailsDeletePhasingInByProductIdRaw(requestParameters: InvestmentDetailsDeletePhasingInByProductIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling investmentDetailsDeletePhasingInByProductId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/{productId}/phase-in`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the phasing in by product identifier.
     */
    async investmentDetailsDeletePhasingInByProductId(requestParameters: InvestmentDetailsDeletePhasingInByProductIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeletePhasingInByProductIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the phasing in target fund.
     */
    async investmentDetailsDeletePhasingInTargetFundRaw(requestParameters: InvestmentDetailsDeletePhasingInTargetFundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.phasingInTargetFundId === null || requestParameters.phasingInTargetFundId === undefined) {
            throw new runtime.RequiredError('phasingInTargetFundId','Required parameter requestParameters.phasingInTargetFundId was null or undefined when calling investmentDetailsDeletePhasingInTargetFund.');
        }

        if (requestParameters.phasingInId === null || requestParameters.phasingInId === undefined) {
            throw new runtime.RequiredError('phasingInId','Required parameter requestParameters.phasingInId was null or undefined when calling investmentDetailsDeletePhasingInTargetFund.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/phase-in/{phasingInId}/target-fund/{phasingInTargetFundId}`.replace(`{${"phasingInTargetFundId"}}`, encodeURIComponent(String(requestParameters.phasingInTargetFundId))).replace(`{${"phasingInId"}}`, encodeURIComponent(String(requestParameters.phasingInId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the phasing in target fund.
     */
    async investmentDetailsDeletePhasingInTargetFund(requestParameters: InvestmentDetailsDeletePhasingInTargetFundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeletePhasingInTargetFundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the recurring contribution premium.
     */
    async investmentDetailsDeleteRecurringContributionPremiumRaw(requestParameters: InvestmentDetailsDeleteRecurringContributionPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.recurringContributionId === null || requestParameters.recurringContributionId === undefined) {
            throw new runtime.RequiredError('recurringContributionId','Required parameter requestParameters.recurringContributionId was null or undefined when calling investmentDetailsDeleteRecurringContributionPremium.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/recurring-contribution/{recurringContributionId}`.replace(`{${"recurringContributionId"}}`, encodeURIComponent(String(requestParameters.recurringContributionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the recurring contribution premium.
     */
    async investmentDetailsDeleteRecurringContributionPremium(requestParameters: InvestmentDetailsDeleteRecurringContributionPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteRecurringContributionPremiumRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the regular withdrawal.
     */
    async investmentDetailsDeleteRegularWithdrawalRaw(requestParameters: InvestmentDetailsDeleteRegularWithdrawalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.regularWithdrawalId === null || requestParameters.regularWithdrawalId === undefined) {
            throw new runtime.RequiredError('regularWithdrawalId','Required parameter requestParameters.regularWithdrawalId was null or undefined when calling investmentDetailsDeleteRegularWithdrawal.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/regular-withdrawal/{regularWithdrawalId}`.replace(`{${"regularWithdrawalId"}}`, encodeURIComponent(String(requestParameters.regularWithdrawalId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the regular withdrawal.
     */
    async investmentDetailsDeleteRegularWithdrawal(requestParameters: InvestmentDetailsDeleteRegularWithdrawalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteRegularWithdrawalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the tfsa premium.
     */
    async investmentDetailsDeleteTFSATTransferPremiumRaw(requestParameters: InvestmentDetailsDeleteTFSATTransferPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.transferId === null || requestParameters.transferId === undefined) {
            throw new runtime.RequiredError('transferId','Required parameter requestParameters.transferId was null or undefined when calling investmentDetailsDeleteTFSATTransferPremium.');
        }

        const queryParameters: any = {};

        if (requestParameters.paymentCategoryId !== undefined) {
            queryParameters['paymentCategoryId'] = requestParameters.paymentCategoryId;
        }

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/internal-transfer-new/{transferId}`.replace(`{${"transferId"}}`, encodeURIComponent(String(requestParameters.transferId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the tfsa premium.
     */
    async investmentDetailsDeleteTFSATTransferPremium(requestParameters: InvestmentDetailsDeleteTFSATTransferPremiumRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteTFSATTransferPremiumRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the unit transfer fund.
     */
    async investmentDetailsDeleteUnitTransferRaw(requestParameters: InvestmentDetailsDeleteUnitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.unitTransferFundId === null || requestParameters.unitTransferFundId === undefined) {
            throw new runtime.RequiredError('unitTransferFundId','Required parameter requestParameters.unitTransferFundId was null or undefined when calling investmentDetailsDeleteUnitTransfer.');
        }

        const queryParameters: any = {};

        if (requestParameters.productId !== undefined) {
            queryParameters['productId'] = requestParameters.productId;
        }

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/unit-transfer-fund/{unitTransferFundId}`.replace(`{${"unitTransferFundId"}}`, encodeURIComponent(String(requestParameters.unitTransferFundId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the unit transfer fund.
     */
    async investmentDetailsDeleteUnitTransfer(requestParameters: InvestmentDetailsDeleteUnitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsDeleteUnitTransferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get investment details
     */
    async investmentDetailsFetchRaw(requestParameters: InvestmentDetailsFetchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfInvestmentDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling investmentDetailsFetch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfInvestmentDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get investment details
     */
    async investmentDetailsFetch(requestParameters: InvestmentDetailsFetchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfInvestmentDetailsViewModel> {
        const response = await this.investmentDetailsFetchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save investment details
     */
    async investmentDetailsSubmitFundSelectionRaw(requestParameters: InvestmentDetailsSubmitFundSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling investmentDetailsSubmitFundSelection.');
        }

        if (requestParameters.investmentDetails === null || requestParameters.investmentDetails === undefined) {
            throw new runtime.RequiredError('investmentDetails','Required parameter requestParameters.investmentDetails was null or undefined when calling investmentDetailsSubmitFundSelection.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.isNextStep !== undefined) {
            queryParameters['isNextStep'] = requestParameters.isNextStep;
        }

        if (requestParameters.isComplete !== undefined) {
            queryParameters['isComplete'] = requestParameters.isComplete;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/{productId}/fund-selection`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentDetailsProductViewModelToJSON(requestParameters.investmentDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Save investment details
     */
    async investmentDetailsSubmitFundSelection(requestParameters: InvestmentDetailsSubmitFundSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsSubmitFundSelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save investment details
     */
    async investmentDetailsSubmitInvestmentDetailsRaw(requestParameters: InvestmentDetailsSubmitInvestmentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling investmentDetailsSubmitInvestmentDetails.');
        }

        if (requestParameters.investmentDetails === null || requestParameters.investmentDetails === undefined) {
            throw new runtime.RequiredError('investmentDetails','Required parameter requestParameters.investmentDetails was null or undefined when calling investmentDetailsSubmitInvestmentDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.isNextStep !== undefined) {
            queryParameters['isNextStep'] = requestParameters.isNextStep;
        }

        if (requestParameters.isComplete !== undefined) {
            queryParameters['isComplete'] = requestParameters.isComplete;
        }

        if (requestParameters.proceedWithDataLoss !== undefined) {
            queryParameters['proceedWithDataLoss'] = requestParameters.proceedWithDataLoss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/investment-details/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentDetailsProductViewModelToJSON(requestParameters.investmentDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Save investment details
     */
    async investmentDetailsSubmitInvestmentDetails(requestParameters: InvestmentDetailsSubmitInvestmentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.investmentDetailsSubmitInvestmentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
